module.exports = __webpack_public_path__ + "static/media/dorp.2148d483.jpg";